<template>
    <div id="app" v-if="agePolicyAccepted">
        <router-view></router-view>
        <early-adopter-badge />
        <bug-reporter />
        <notifications group="auth" />
        <md-layout class="loader-wrapper" v-if="selectedLoader">
            <div class="loader">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"><path stroke-dasharray="2 4" stroke-dashoffset="6" d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21"><animate attributeName="stroke-dashoffset" dur="0.6s" repeatCount="indefinite" values="6;0"/></path><path stroke-dasharray="30" stroke-dashoffset="30" d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.1s" dur="0.3s" values="30;0"/></path><path stroke-dasharray="10" stroke-dashoffset="10" d="M12 8v7.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.2s" values="10;0"/></path><path stroke-dasharray="6" stroke-dashoffset="6" d="M12 15.5l3.5 -3.5M12 15.5l-3.5 -3.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.2s" values="6;0"/></path></g></svg>
            </div>
        </md-layout>
        <md-layout class="loader-wrapper-login" v-else-if="selectedLoaderLogin">
            <div class="loader">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                        <path stroke-dasharray="2 4" stroke-dashoffset="6" d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21">
                            <animate attributeName="stroke-dashoffset" dur="0.6s" repeatCount="indefinite" values="6;0"/>
                        </path>
                        <path stroke-dasharray="30" stroke-dashoffset="30" d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3">
                            <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.1s" dur="0.3s" values="30;0"/>
                        </path>
                    </g>
                </svg>
            </div>
        </md-layout>
    </div>
    <div v-else class="age_certify_policy_popup flex-container">
        <md-layout md-vertical-align="center">
            <md-layout md-flex="30" md-flex-offset="35" md-align="center">
                <h1>
                    <span class="sr-only">Cuelist</span>
                    <img :src="require('./assets/img/cuelistBLACK.png')" alt=""/>
                </h1>
            </md-layout>
            <md-layout md-flex="100" md-align="center">
                <h2 class="md-headline">An innovative, paperless tool that is reinventing<br/>collaboration for theater and live events</h2>
            </md-layout>
            <md-layout md-flex="100" md-align="center" md-column style="font-size: 16px; font-weight: 400; letter-spacing: 0; line-height: 22px; text-align: center;">
                <p style="margin-bottom: 0;">Cuelist is an excellent tool for professionals and students alike. But, in order to access Cuelist,<br/>you must be at least 13 years old. Please verify your age before proceeding.</p>
                <p style="margin-top: 0;"><md-checkbox v-model="agePolicyAccepted" class="md-primary" @change="updateAgeCertifyPolicy">I certify I am at least 13 years of age.</md-checkbox></p>
            </md-layout>
        </md-layout>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BugReporter from '@/components/BugReporter';
import EarlyAdopterBadge from '@/components/EarlyAdopterBadge';

const app = {
    name: 'app',
    components: {
        'bug-reporter': BugReporter,
        'early-adopter-badge': EarlyAdopterBadge
    },
    data: function() {
        return {
            currentUID: null,
            agePolicyAccepted: false
        };
    },
    computed: {
        ...mapGetters([
            'selectedLoader',
            'selectedLoaderLogin'
        ])
    },
    methods: {
        updateAgeCertifyPolicy(status) {
            localStorage.setItem('age_certify_policy_accepted', status);
            this.$store.dispatch('setLoader', {
                type: false
            });
        },
        // The create-checkout-session duplicate-subscription guard bounces the
        // user back with ?subscribe=already_active instead of minting a second
        // subscription. Surface why, then strip the param so it doesn't re-fire.
        handleSubscribeRedirect() {
            const params = new URLSearchParams(window.location.search);
            if (params.get('subscribe') === 'already_active') {
                if (this.$toast && this.$toast.info) {
                    this.$toast.info('You already have an active subscription. To change your plan, use Manage Billing on your account page.');
                }
                params.delete('subscribe');
                const qs = params.toString();
                const url = window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash;
                window.history.replaceState({}, document.title, url);
            }
        }
    },
    mounted: function() {
        this.agePolicyAccepted = localStorage.getItem('age_certify_policy_accepted') || false;
        this.handleSubscribeRedirect();
    }
};

export default app;


</script>

<style lang="scss">
    *::-webkit-scrollbar{
        width: 8px;
    }

    *::-webkit-scrollbar-track {
        background: #EEE
    }

    *::-webkit-scrollbar-thumb {
        background: #868585;
    }

    * {
        scrollbar-width: thin;
        scrollbar-color: #868585 #EEE
    }

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}

body {
    height: 100%;
}
#app {
    height: 100%;
    min-height: 100%;
    form {
        width: 100%;
        text-align: center;
    }
    .user-defined-form{
        text-align: left;
        width: 49%;
        display: flex;
        align-items: center;
    }
    .md-sidenav {
        .md-backdrop {
            position: fixed;
            z-index: 999;
        }
        .md-sidenav-content {
            position: fixed;
            z-index: 1000;
            form {
                text-align: left;
            }
        }
    }
    .loader-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.575);
        z-index: 99999;
        display: flex;
        justify-content: center;
        align-items: center;

        .loader, svg {
            width: 64px;
            height: 64px;
        }

        svg {
            color: #fff;
        }
    }
    .loader-wrapper-login {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 99999;
        display: flex;
        justify-content: center;
        align-items: center;

        .loader, svg {
            width: 64px;
            height: 64px;
        }

        svg {
            color: #fff;
        }
    }
}
// Messages sit above every dialog and the loader. project-settings/nav.vue sets every open
// dialog to z-index 9999 (unscoped), the same as vue-toastification's container, and a dialog
// is appended to <body> when it opens, so it won the tie and its backdrop dimmed the message
// (Josh, 14 Oct: "Failed to save version" behind the Save & Continue dialog's scrim).
body .Vue-Toastification__container {
    z-index: 100000;
}
.container {
    height: 100%;
    min-height: 100%;
}
.flex-container {
    height: 100%;
    min-height: 100%;
    display: flex;
    h1,h2 {
        text-align: center;
        width: 100%;
    }
}

.age_certify_policy_popup {
    padding: 1rem;
}

// clean UI theme
.md-theme-default, .md-theme-show-mode {
    &.md-button {
        &:not([disabled]) {
            &.md-raised {
                background-color: #5ecfdf !important;
                color: #000 !important;
                &:hover {
                    background-color: lighten(#5ecfdf, 5%) !important;
                }
            }
        }
    }
    .md-ink-ripple {
        color: #5ecfdf !important;
    }
    &.md-checkbox.md-checked {
        .md-checkbox-container {
            background-color: #5ecfdf !important;
            border-color: #5ecfdf !important;
        }
    }
    &.md-radio.md-checked {
        .md-radio-container {
            border-color: #5ecfdf !important;
            &:after {
                background-color: #5ecfdf !important;
            }
        }
    }
}

.md-theme-show-mode {
    .md-input-container {
            input, textarea, .md-input, label {
                color: rgba(255, 255, 255, 0.87) !important;
            }
        &:after {
            background-color: rgba(255, 255, 255, 0.12) !important;
        }
    }
    .md-list-text-container {
        span {
            color: rgba(255, 255, 255, 0.87) !important;
        }
    }
    .md-list-item .md-icon {
        color: rgba(255, 255, 255, 0.87);
    }
    &.pendingCollaboratorList {
        .md-list-text-container {
            span {
                color: rgba(0, 0, 0, 0.87) !important;
            }
        }
        .md-list-item .md-icon {
            color: rgba(0, 0, 0, 0.54);
        }
        .md-button {
            color: rgba(0, 0, 0, 0.54);
        }
    }
    .collaborator-text-container {
        span {
            color: rgba(255, 255, 255, 0.87) !important;
        }
    }
    .md-dialog-actions {
        .md-button {
            color: #fff !important;
        }
    }
    &.md-checkbox {
        .md-checkbox-container {
            background-color: #fff !important;
        }
    }
    &.md-radio {
        .md-radio-container {
            border-color: #fff !important;
        }
    }
}

.md-toolbar {
    &.main-toolbar {
        background-color: #0d2744 !important;
    }
}

.layout-separator {
    margin-bottom: 35px;
}

.md-avatar {
    img {
        object-fit: cover;
    }
}
</style>


// WEBPACK FOOTER //
// App.vue?798c71c0